/**
 * @generated SignedSource<<2a461a3c25b918939e9d8a0a41a0a36a>>
 * @relayHash 5063dabd883604b31f448c60ea62e531
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0b1908e692a7aa5fc47c8b8f0d71d31204d850b421d061ad77e7cbb8ed5eccc4

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AtlaskitAtlassianNavigationNav4UIQuery$variables = {
  cloudId: string;
  includeExtraMenuItems: boolean;
  isAnonymous: boolean;
};
export type AtlaskitAtlassianNavigationNav4UIQuery$data = {
  readonly jira: {
    readonly navigationUIState: {
      readonly isLeftSidebarCollapsed: boolean;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"Nav4NotificationsData" | "Nav4Profile">;
};
export type AtlaskitAtlassianNavigationNav4UIQuery = {
  response: AtlaskitAtlassianNavigationNav4UIQuery$data;
  variables: AtlaskitAtlassianNavigationNav4UIQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeExtraMenuItems"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isAnonymous"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isLeftSidebarCollapsed"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AtlaskitAtlassianNavigationNav4UIQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraNavigationUIStateUserProperty",
              "kind": "LinkedField",
              "name": "navigationUIState",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v2/*: any*/),
                  "action": "THROW",
                  "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "kind": "FragmentSpread",
        "name": "Nav4Profile"
      },
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Nav4NotificationsData"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AtlaskitAtlassianNavigationNav4UIQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraNavigationUIStateUserProperty",
            "kind": "LinkedField",
            "name": "navigationUIState",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "condition": "includeExtraMenuItems",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "email"
                      }
                    ],
                    "type": "AtlassianAccountUser"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "unseenNotificationCount"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0b1908e692a7aa5fc47c8b8f0d71d31204d850b421d061ad77e7cbb8ed5eccc4",
    "metadata": {},
    "name": "AtlaskitAtlassianNavigationNav4UIQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6fefcd1fdd1316e2af1f4f9d895a7580";

export default node;
